module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAKCAYAAAC5Sw6hAAAAAXNSR0IArs4c6QAAAMFJREFUKFOd0bEOgjAQBuD/19XFt3NQg0RXaFycfQHSdtWoMTyfLm4GzxwBgkCM9rY2+b/eXWmt3ZPcApggrB4iktE5dwMwDTOa1F2hGYAcwDgQK0guqGFr7ZzkJQArRCQyxuQlVGFLkqc/MEViY8xV8w2kB+99JCLHHzAdZ50kiU5R1gekF865FYDDF6wAsEnT9NzeaQ9qYdrZqPMBLwDrLjLYUR303sfVmPVjUo2je+zVYEedD8gAPEVkVy92CHoD+xFH7PiNhOQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/tree-open-icon.png
// module id = I9BD
// module chunks = 1